import { render, staticRenderFns } from "./ArticleCount.vue?vue&type=template&id=47588472&scoped=true&"
import script from "./ArticleCount.vue?vue&type=script&lang=js&"
export * from "./ArticleCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47588472",
  null
  
)

export default component.exports